import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ChatProvider } from './contexts/ChatContext';
import { ConversationProvider } from './contexts/ConversationContext';
import ProtectedRoute from './components/ProtectedRoute';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import OfflineDetector from './components/OfflineDetector';
import Login from './pages/Login';
import PasswordReset from './pages/PasswordReset';
import PasswordResetConfirm from './pages/PasswordResetConfirm';
import LeadsDesktopShell from './components/LeadsDesktopShell';
import ClientsDesktopShell from './components/ClientsDesktopShell';
import PageDesktopShell from './components/PageDesktopShell';
import ChatConversation from './pages/ChatConversation';
import ChatPreview from './pages/ChatPreview';
import CustomerDetails from './pages/CustomerDetails';
import Campaign from './pages/Campaign';
import Settings from './pages/Settings';
import MyProfile from './pages/MyProfile';
import ChangePassword from './pages/ChangePassword';
import NotificationSettings from './pages/NotificationSettings';
import LoadingState from './components/dashboard/LoadingState';

// Chunk próprio: os gráficos (recharts) só baixam quando a página de métricas abre.
const Metrics = lazy(() => import('./pages/Metrics'));

export default function MobileRoutes() {
  return (
    <ChatProvider>
      <ConversationProvider>
        <PWAInstallPrompt />
        <OfflineDetector />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/password-reset/confirm/:uid/:token" element={<PasswordResetConfirm />} />

          {/* Leads: WhatsApp-like split layout on desktop */}
          <Route
            path="/leads"
            element={
              <ProtectedRoute>
                <LeadsDesktopShell />
              </ProtectedRoute>
            }
          >
            <Route path=":id" element={<ChatConversation />} />
            <Route path=":id/preview" element={<ChatPreview />} />
            <Route path=":id/customer" element={<CustomerDetails />} />
          </Route>

          {/* Clients: two-pane desktop layout (list + details) */}
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <ClientsDesktopShell />
              </ProtectedRoute>
            }
          >
            <Route path=":id" element={<CustomerDetails />} />
          </Route>

          {/* Other pages — wrapped in PageDesktopShell for desktop sidebar nav */}
          <Route element={<ProtectedRoute><PageDesktopShell /></ProtectedRoute>}>
            <Route path="/customer-details/:id" element={<CustomerDetails />} />
            <Route path="/campaigns/:id" element={<Campaign />} />
            <Route path="/metrics" element={<Suspense fallback={<LoadingState />}><Metrics /></Suspense>} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/profile" element={<MyProfile />} />
            <Route path="/settings/change-password" element={<ChangePassword />} />
            <Route path="/settings/notifications" element={<NotificationSettings />} />
          </Route>
          <Route path="/chats/*" element={<Navigate to="/leads" replace />} />

          {/* TODO v1: business routes — hidden for v0 */}

          <Route path="/" element={<Navigate to="/leads" replace />} />
          <Route path="*" element={<Navigate to="/leads" replace />} />
        </Routes>
      </ConversationProvider>
    </ChatProvider>
  );
}
